<template>
  <form @submit.prevent="$emit('submit')" class="availability-form">
    <div class="form-row">
      <div class="form-group-modern">
        <label class="form-label">
          <span class="label-icon">👥</span>
          {{ $t("experiences.people") }}
        </label>
        <input
          type="number"
          :value="people"
          @input="$emit('update:people', parseInt($event.target.value) || 1)"
          min="1"
          class="form-input-modern"
          required
          placeholder="1"
        >
      </div>

      <div class="form-group-modern">
        <label class="form-label">
          <span class="label-icon">🌐</span>
          {{ $t("experiences.language") }}
        </label>
        <select
          :value="language"
          @input="$emit('update:language', $event.target.value)"
          class="form-input-modern"
          required
        >
          <option value="pt">Portugues</option>
          <option value="en">English</option>
        </select>
      </div>
    </div>

    <div class="form-group-modern">
      <label class="form-label">
        <span class="label-icon">📅</span>
        {{ $t("experiences.date") }}
      </label>
      <DatePicker :value="date" @input="$emit('update:date', $event)" />
    </div>

    <button
      type="submit"
      class="btn-check-availability"
      :disabled="!date || date.trim() === ''"
      :class="{ 'btn-disabled': !date || date.trim() === '' }"
    >
      <span>{{ $t("experiences.checkAvailability") }}</span>
      <svg class="btn-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M4 10H16M16 10L11 5M16 10L11 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </form>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";

export default {
  name: 'AvailabilityForm',
  components: {
    DatePicker
  },
  props: {
    people: {
      type: Number,
      default: 1
    },
    language: {
      type: String,
      default: 'pt'
    },
    date: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.availability-form {
  margin-bottom: 2rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-group-modern {
  margin-bottom: 1.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--secondary-color);
}

.label-icon {
  font-size: 1.2rem;
  line-height: 1;
}

.form-input-modern {
  width: 100%;
  padding: 0.875rem 1.25rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #ffffff;
  color: var(--secondary-color);
  font-family: inherit;
}

.form-input-modern:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(177, 209, 160, 0.1);
}

.form-input-modern:hover {
  border-color: #d1d5db;
}

select.form-input-modern {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 3rem;
}

.btn-check-availability {
  width: 100%;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, var(--primary-color) 0%, #9fc48a 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(177, 209, 160, 0.3);
  margin-top: 0.5rem;
}

.btn-check-availability:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(177, 209, 160, 0.4);
  background: linear-gradient(135deg, #9fc48a 0%, var(--primary-color) 100%);
}

.btn-check-availability:disabled,
.btn-check-availability.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #d1d5db;
  box-shadow: none;
}

.btn-check-availability:disabled:hover,
.btn-check-availability.btn-disabled:hover {
  transform: none;
  box-shadow: none;
  background: #d1d5db;
}

.btn-icon {
  transition: transform 0.3s ease;
}

.btn-check-availability:hover .btn-icon {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
</style>
